<template>
	<div class="con">
		<div class="head">
			<img src="../assets/home.jpg" />
		</div>
		<div class="con-text">
			{{textHospital}}
		</div>
		<div class="box-map">
			<baidu-map class="map-view" :center="markerPoint" :zoom="30">
				<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true" ></bm-geolocation>

				<bm-marker :position="markerPoint" :dragging="true" @click="infoWindowOpen">
					<bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen" style="font-size: 13px">
						天峨县妇幼保健院 <br /><br />
						电话：0778-7822330 <br /><br />
						地址：广西壮族自治区河池市天峨县六排镇建设巷002号
					</bm-info-window>
				</bm-marker>
			</baidu-map>
		</div>
		<div class="coute">
			<div>1、可乘公交 1 路 到五吉大酒店站下车向五吉右后侧走150米</div>
			<div>2、可乘公交 2 路 到国土资源局站下车向五吉右后侧走160米</div>
			<div>注：接种、婚检人员请往六排镇新民街24号（广场分院）2楼、5楼</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Inintroduce',
		data() {
			return {
				center: {
					lng: 0,
					lat: 0
				},
				zoom: 19,
				markerPoint: {
					lng: 107.181667,
					lat: 24.996428
				},
				show: true,
				textHospital: this.$store.state.hospital
			}
		},
		methods: {
			handler({
				BMap,
				map
			}) {
				console.log(BMap, map);
				this.center.lng = 107.181667;
				this.center.lat = 24.996428;
				this.zoom = 17;
			},

			infoWindowClose() {
				this.show = false;
			},

			infoWindowOpen() {
				this.show = true;
			},

			locationSuccess(point, AddressComponent, marker) {
				console.log("定位成功");
				console.log(point);
				console.log(AddressComponent);
				console.log(marker);
			},

		},
		mounted() {}
	}
</script>

<style scoped>
	.head img {
		width: 100%;
		max-width: 100%;
		max-height: 400px;
	}

	.con-text {
		padding: 10px;
		font-size: 15px;
		text-indent: 2em;
		line-height: 25px;
	}

	.map-view {
		margin: 0 auto;
		width: 90%;
		height: 50vh;
		border-radius: 8px;
		overflow: hidden;
	}
	.coute{
		margin: 10px auto;;
		width: 90%;
		font-size: 14px;
		color: #666;
	}
</style>
